var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 53.5211,
    height: 53.5211,
    rx: 21.9846,
    fill: "#256A9D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8611 18.1431L33.3006 18.1431C34.2453 18.1431 35.1513 17.7678 35.8193 17.0998C36.4873 16.4318 36.8626 15.5258 36.8626 14.5811C36.8626 13.6364 36.4873 12.7303 35.8193 12.0623C35.1513 11.3943 34.2453 11.019 33.3006 11.019L26.8101 11.019C25.8634 11.0422 24.9568 11.4054 24.256 12.0422C23.5552 12.679 23.1071 13.5468 22.9936 14.4869C22.6349 17.68 20.4799 19.9572 17.1418 20.3795C15.5007 20.5856 14.1675 22.1605 14.1675 23.799L14.1675 35.5791C14.1675 37.4152 14.8969 39.1761 16.1952 40.4744C17.4935 41.7728 19.2544 42.5022 21.0905 42.5022L34.5753 42.5022C35.52 42.5022 36.426 42.1269 37.094 41.4589C37.762 40.7909 38.1373 39.8848 38.1373 38.9401C38.1373 37.9954 37.762 37.0894 37.094 36.4214C36.426 35.7534 35.52 35.3781 34.5753 35.3781L22.8512 35.3781C22.6471 35.3781 22.4451 35.3379 22.2566 35.2597C22.0682 35.1816 21.897 35.067 21.7528 34.9227C21.6087 34.7783 21.4944 34.6069 21.4165 34.4183C21.3387 34.2297 21.2988 34.0276 21.2991 33.8236L21.2991 21.7051C21.2991 20.7604 21.6744 19.8544 22.3424 19.1864C23.0104 18.5184 23.9164 18.1431 24.8611 18.1431Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c19fb37f6244b35157f9e186bf3ede11.svg";
export { ForwardRef as ReactComponent };